<template>
  <m-card-item
    class="saved-view-item"
    :active="active"
    :style="{'font-weight': '500'}"
    :data-id="view.uid"
    @click="selectView(view)"
  >
    <div
      v-if="showDragHandle"
      class="_handle"
    >
      <m-icon
        type="drag"
        :color="$colors.grey.base"
      />
    </div>
    <saved-view-title
      :view="view"
      :show-visibility-hint="showVisibilityHint"
    />
    <template #right>
      <div
        class="_actions"
      >
        <m-dropdown
          v-if="view.canEdit"
          v-model:value="showEditor"
          placement="topRight"
          :title="$t('general.actions')"
        >
          <m-btn
            hide-border
            icon="ellipsis"
            fab
            xs
            @click.stop="showEditor = true"
          />
          <template #overlay>
            <m-card
              list
            >
              <m-card-item
                icon="edit"
                @click="$emit('open-editor', view)"
              >
                {{ $t('general.rename') }}
              </m-card-item>
              <m-card-item
                icon="settings"
                @click="$emit('open-editor', view)"
              >
                {{ $t('savedViewSelector.editView') }}
              </m-card-item>
              <m-card-item
                icon="copy"
                @click="$emit('duplicate', view)"
              >
                {{ $t('savedViewSelector.duplicate') }}
              </m-card-item>
              <template v-if="view !== null && !disableDelete">
                <m-divider xxs />
                <m-card-item
                  icon="delete"
                  @click="$emit('delete', view)"
                >
                  {{ $t('general.delete') }}
                </m-card-item>
              </template>
            </m-card>
          </template>
        </m-dropdown>
      </div>
    </template>
  </m-card-item>
</template>

<script>
import SavedViewTitle from '@/components/list/SavedViewTitle.vue';
import useAccess from '@/composables/access/access';
import { accessGroupFlag, viewType } from 'shared/constants.json';
import { iconByType } from '@/lib/saved-view/saved-view';

export default {
  name: 'SavedViewItem',
  props: {
    view: {
      type: Object,
      required: true,
    },
    allowedViewTypes: {
      type: Array,
      default: () => [],
    },
    viewApplication: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    showDragHandle: {
      type: Boolean,
      default: false,
    },
    showVisibilityHint: {
      type: Boolean,
      default: false,
    },
    disableDelete: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['select', 'delete', 'open-editor', 'duplicate'],
  components: { SavedViewTitle },
  setup() {
    const { userHasRight } = useAccess();
    return { userHasRight };
  },
  data() {
    return { showEditor: false, viewType };
  },
  computed: {
    typeIcon() {
      return iconByType(this.view.viewType);
    },
    hasPublicViewAccess() {
      return this.userHasRight([accessGroupFlag.publicSavedViews]);
    },
  },
  methods: {
    selectView(view) {
      this.$emit('select', view);
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>

  .saved-view-item {
    ._handle {
      margin: 0 .4rem 0 -.3rem;
      cursor: grab;
    }

    ._actions {
      display: flex;
      align-items: center;
    }
  }

</style>
